import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { createCategory, addBrand, addType, getBrandByID, Baseurl, updateBrandByID, updateCategoryData , getCategoryByID
  , getCategById, addAuthor, addBlog, createbaner, getSingleBaner,updateBaner, promocode, createCountry, updateCountry,
  getCountryByid, getFooter, createFooter, getAuthorByID, getUser, editUser, createEmirate, getSingleEmirate, editEmirate,
  getcodeById,
  editCodeById,
  editBlog,
  updateAuthorData,
  createBoy,
  getSingleBoy,
  editBoy,
} from '../../../service/apiService';
import FormData from 'form-data'
import { Editor } from 'primereact/editor';
import { Calendar } from 'primereact/calendar';
import FilterImgDrop from '../ImageDropdown/FilterImgDrop';
import { SelectButton } from 'primereact/selectbutton';
import ImageCropper from '../imagecroper/Imagecroper';
import { enqueueSnackbar } from 'notistack';

const Addmodal = (props) => {
const [name,setName] = useState('') 
const [lastname,setLastname] = useState() 
const [password,setPassword] = useState() 
const [mobile,setMobile] = useState() 
const [price,setPrice] = useState() 


const [email,setEmail] = useState() 
const [author,setAuthor] = useState()
 const [formimage, setFormImage] = useState(); 
 const [date, setDate] = useState();
const [description, setDescription] = useState();
const [titletwo, setTitletwo] = useState();
const [titlethree, setTitlethree] = useState();

const [facebook, setFacebook] = useState();
const [instagram, setInstagram] = useState();
const [youtube, setYoutube] = useState();
const [updateid, setUpdateId] = useState();
const [whatsaap, setWhatsaap] = useState();



const options = ['Yes', 'No'];
const options2 = ['Amount', 'Percentage'];
const [discountPer, setDiscountPer] = useState();
const [discountamount, setDiscountamount] = useState();
const [minimumpurchaserate, setMinimumpurchaserate] = useState();
const [redemtionlimit, setRedemtionlimit] = useState();
const [valid, setValid] = useState(options[0]);
const [disctype, setDisctype] = useState(options2[0]);
 const image = useRef()
 const image2 = useRef()
 const image3 = useRef()
 const [formimage2, setFormImage2] = useState(); 
 const [formimage3, setFormImage3] = useState(); 



 const handleImageChange = (event) => {
  event.preventDefault()
  if (event.target.files && event.target.files[0]) {
    let reader = new FileReader();
    reader.onload = (e) => {
      setFormImage(e.target.result);
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}; 
const handleImageChange2 = (event) => {
  event.preventDefault()
  if (event.target.files && event.target.files[0]) {
    let reader = new FileReader();
    reader.onload = (e) => {
      setFormImage2(e.target.result);
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}; 
const handleImageChange3 = (event) => {
  event.preventDefault()
  if (event.target.files && event.target.files[0]) {
    let reader = new FileReader();
    reader.onload = (e) => {
      setFormImage3(e.target.result);
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}; 

const handleRemoveImage = () => {
  try{
    image.current.value = null
    image.current.file = null
    setFormImage(null);
  }catch(err){
    console.log(err); 
  }
};
const handleRemoveImage2 = () => {
  try{
    image2.current.value = null
    image2.current.file = null
    setFormImage2(null);
  }catch(err){
    console.log(err); 
  }
};
const handleRemoveImage3 = () => {
  try{
    image3.current.value = null
    image3.current.file = null
    setFormImage3(null);
  }catch(err){
    console.log(err); 
  }
};

const handleSubmit = async () => {

if(props.category === 'category'){
 let params = new FormData();
  params.append('name',name)
  params.append('image',image.current.files[0])
 let result = await createCategory(params)
 if(result?.status === 200){
    props.handleClose()
    props.initRefresh()
    handleRemoveImage()
    return
 }
 props.handleClose()
 handleRemoveImage()
}

if(props.brand === 'brand'){
  let params = new FormData();
  params.append('name',name)
  params.append('image',image.current.files[0])
let result = await addBrand(params)
if(result?.status === 200){
  props.handleClose()
  props.initRefresh()
  handleRemoveImage()
  return
}
props.handleClose()
handleRemoveImage()
}

if(props.type === 'type'){
  let params = {
      name
  }
let result = await addType(params)
if(result?.status === 200){
  props.handleClose()
  props.initRefresh()
  return
}
props.handleClose()
}

if(props.brand === 'editbrand'){
  console.log( name , formimage );
  console.log(image.current.files,'image.current.files[0]');
  console.log(formimage,'formimage');
  
  if(image?.current?.files){
    let params = new FormData();
    params.append('name',name)
    params.append('image',image.current.files[0])
    params.append('id',props.idtodelete) 
    let result = await updateBrandByID(props.idtodelete,params)
if(result?.status === 200){
  props.handleClose()
  props.initRefresh()
  handleRemoveImage()
  return
}
props.handleClose()
handleRemoveImage()
  }
  let params = new FormData();
  params.append('name',name) 
  params.append('id',props.idtodelete) 

let result = await updateBrandByID(props.idtodelete,params)
if(result?.status === 200){
  props.handleClose()
  props.initRefresh()
  handleRemoveImage()
  return
}
props.handleClose()
handleRemoveImage()
}

if(props.category === 'editcategory'){
  
  if(image?.current?.files){
    let params = new FormData();
    params.append('name',name)
    params.append('image',image.current.files[0])
    params.append('id',props.idtodelete) 
    let result = await updateCategoryData(props.idtodelete,params)
if(result?.status === 200){
  props.handleClose()
  props.initRefresh()
  handleRemoveImage()
  return
}
props.handleClose()
handleRemoveImage()
  }
  let params = new FormData();
  params.append('name',name) 
  params.append('id',props.idtodelete) 

let result = await updateCategoryData(props.idtodelete,params)
if(result?.status === 200){
  props.handleClose()
  props.initRefresh()
  handleRemoveImage()
  return
}
props.handleClose()
handleRemoveImage()
} 

if(props.from === 'author'){
  let params = new FormData();
   params.append('name',name)
   params.append('image',image.current.files[0])
  let result = await addAuthor(params)
  if(result?.status === 200){
     props.handleClose()
     props.initRefresh()
     handleRemoveImage()
     return
  }
  props.handleClose()
  handleRemoveImage()
 }

if(props.from === 'editauthor'){
  let params = new FormData();
   params.append('name',name)
   params.append('image',image.current.files[0])
  let result = await updateAuthorData(props.id,params)
  if(result?.status === 200){
     props.handleClose()
     props.initRefresh()
     handleRemoveImage()
     return
  }
  props.handleClose()
  handleRemoveImage()
 }

 if(props.from === 'blog'){
   let params = new FormData();
    params.append('name',name)
    params.append('description',description)
    params.append('author',author)
    params.append('date',date)
    params.append('active', valid === 'Yes' ? true :false)
    params.append('image',image.current.files[0])
try{
  let result = await addBlog(params)
  if(result?.status === 200){
    props.handleClose()
    enqueueSnackbar('Blog Added',{variant:'success'})
    props.initRefresh()
    return
  }
    } catch (err) {
    console.log(err, 'blogerror');
    enqueueSnackbar(`${err?.response.data.failed}`, { variant: 'error' });
    props.handleClose();
    return; 
  }
  console.log('blogtesttt');
  
  props.handleClose()
  }
 
if(props.from === 'editblog'){
  let params = new FormData();
    params.append('name',name)
    params.append('description',description)
    params.append('author',author)
    params.append('date',date)
    params.append('active', valid === 'Yes' ? true :false)
    params.append('image',image.current.files[0])
  let result = await editBlog(props?.id,params)
  if(result?.status === 200){
    props.handleClose()
    enqueueSnackbar('Blog Edited',{variant:'success'})
    props.initRefresh()
    return
  }
  props.handleClose()
}  

  if(props.from === 'baner'){
    let params = new FormData();
     params.append('name',name)
     params.append('img',image.current.files[0])
     params.append('heading',titletwo)
     params.append('button',titlethree)
    let result = await createbaner(params)
    if(result?.status === 200){
       props.handleClose()
       props.initRefresh()
       handleRemoveImage()
       return
    }
    props.handleClose()
    handleRemoveImage()
   }  
   if(props.from === 'editbaner'){
    let params = new FormData();
    params.append('name',name)
     params.append('img',image?.current?.files[0])
     params.append('heading',titletwo)
     params.append('button',titlethree)
    let result = await updateBaner(props.uniqueId,params)
    if(result?.status === 200){
       props.handleClose()
       props.initRefresh()
       handleRemoveImage()
       return
    }
    props.handleClose()
    handleRemoveImage()
   }
if(props.from === 'code'){
  console.log(typeof(disctype),typeof(minimumpurchaserate), typeof(redemtionlimit), 'kk');
    console.log(disctype,minimumpurchaserate, redemtionlimit, 'kk');

  if (disctype === 'Percentage' && !redemtionlimit ) {
    return alert('Please enter All details')
  }
  if (disctype === 'Percentage' && (redemtionlimit === 0 || redemtionlimit === '0') ) {
    return alert('Redemtionlimit cannot be zero')
  } 
  if (minimumpurchaserate === 0 || minimumpurchaserate === '0' ) {
    return alert('Minimum purchase rate cannot be zero')
  }
  if (!name || !description || !disctype || !minimumpurchaserate || !discountamount || !date) {
    return alert('Please enter All details')
  }
  let params = {
    Name:name,
    description,
    discountType: disctype,
    minimumPurchaseRate: minimumpurchaserate,
    maximumRedemtionLimit: redemtionlimit || 0 ,
    discount: discountamount,
    valid: valid === 'Yes' ? true :false,
    expiryDate: date
  }
    let result = await promocode(params)
    if(result?.status === 200){
       props.handleClose()
       props.initRefresh()
       return
    }
    props.handleClose()
   }    
   if(props.from === 'country'){
    let params = new FormData();
    params.append('name',name)
    params.append('image',image.current.files[0])
      let result = await createCountry(params)
      if(result?.status === 200){
         props.handleClose()
         props.initRefresh()
         return
      }
      props.handleClose()
     } 
     if(props.from === 'editcountry'){
      let params = new FormData();
      params.append('name',name)
      params.append('image',image.current.files[0])
        let result = await updateCountry(props.uniqueId,params)
        if(result?.status === 200){
           props.handleClose()
           props.initRefresh()
           return
        }
        props.handleClose()
       }
       if(props.from === 'updatefooter'){
        let params = new FormData();
        params.append('name',name)
        params.append('image',image.current.files[0])
        params.append('description',description)
        params.append('facebook',facebook)
        params.append('instagram',instagram)
        params.append('youtube',youtube)
        params.append('whatsappNumber',whatsaap)

          let result = await createFooter(updateid,params)
          if(result?.status === 200){
             props.handleClose()
             props.initRefresh()
             return
          }
          props.handleClose()
         }   
if(props.from === 'edituser'){
let params = new FormData
params.append('name',name)
params.append('lastname',lastname)
params.append('image',image.current.files[0])
params.append('email',email)
params.append('mobile',mobile)
params.append('password',password)
let res = await editUser(params,props.id)
if(res?.status === 200){
  props.handleClose()
  props.refresh()
  return
}
props.handleClose()
}

if(props.from === 'emirates'){
  let params = {
    name: name,
    price: price
  } 
  let res = await createEmirate(params)
  if(res?.status === 200){
    props.handleClose()
    props.initRefresh()
    return
  }
  props.handleClose()
  
}

if(props.from === 'editEmirates'){
  let params = {
    name: name,
    price: price
  } 
  let res = await editEmirate(params,props.id)
  if(res?.status === 200){
    props.handleClose()
    props.initRefresh()
    return
  }
  props.handleClose()
  
}
if(props.from === 'editcode' ){
  if (disctype === 'Percentage' && !redemtionlimit ) {
     alert('Please enter All details')
     return
  }
  if (disctype === 'Percentage' && (redemtionlimit === 0 || redemtionlimit === '0') ) {
     alert('Redemtionlimit cannot be zero ')
     return
  } 
  if (minimumpurchaserate === 0 || minimumpurchaserate === '0' ) {
     alert('Minimumpurchaserate cannot be zero ')
     return
  }
  if (!name || !description || !disctype || !minimumpurchaserate || !discountamount || !date) {
     alert('Please enter All details ')
     return
  }
  let params = {
    Name:name,
    description,
    discountType: disctype,
    minimumPurchaseRate: minimumpurchaserate,
    maximumRedemtionLimit: disctype === 'Percentage' ?  redemtionlimit : 0  ,
    discount: discountamount,
    valid: valid === 'Yes' ? true :false,
    expiryDate: date
  }
    let result = await editCodeById(props.uniqueId, params)
    if(result?.status === 200){
       props.handleClose()
       props.initRefresh()
       return
    }
    props.handleClose()
   
}
if(props.from === 'addboy'){

    if (!name || !mobile || !email) {
    return alert('Please enter All details ')
  }
  let params = {
    name:name,
    mobile,
    email
  }
    let result = await createBoy(params)
    if(result?.status === 200){
       props.handleClose()
       props.initRefresh()
       return
    }
    props.handleClose()
   
}

if( props.from === 'editboy'){

    if (!name || !mobile || !email) {
    return alert('Please enter All details ')
  }
  let params = {
    name:name,
    mobile,
    email
  }
    let result = await editBoy(params, props?.id)
    if(result?.status === 200){
       props.handleClose()
       props.initRefresh()
       return
    }
    props.handleClose()
   
}

}

const init = async () => {
if(props.brand === 'editbrand'){
  let result = await getBrandByID(props.idtodelete)
  setName(result.data.data[0].name)
  setFormImage(`${Baseurl}/view/imageupload/${result.data.data[0].img} `)  
}
if(props.category === 'editcategory'){
  let result = await getCategById(props.idtodelete)
  setName(result.data.data.name)
  setFormImage(`${Baseurl}/view/imageupload/${result.data.data.img} `)  
}

if(props.from === 'editcountry'){
  let result = await getCountryByid(props.uniqueId)
  setName(result?.data?.name)
  setFormImage(`${Baseurl}/view/imageupload/${result?.data?.img} `)  
}

if(props.from === 'editbaner'){
 let result = await getSingleBaner(props.uniqueId)
 setName(result?.data?.name)
 setFormImage(`${Baseurl}/view/imageupload/${result.data.img}`)
 setTitletwo(result?.data?.heading)
 setTitlethree(result?.data?.button)
}
if(props.from === 'updatefooter'){
  let result = await getFooter()
  if(result) {
    setName(result?.data[0]?.name)
    setUpdateId(result.data[0]._id)
    setFormImage(`${Baseurl}/view/imageupload/${result.data[0].img}`)
    setDescription(result?.data[0]?.description)
    setFacebook(result?.data[0]?.facebook)
    setInstagram(result?.data[0]?.instagram)
    setYoutube(result?.data[0]?.youtube)
    setWhatsaap(result?.data[0]?.whatsappNumber)
  }
}
if(props.from === 'editauthor'){
  let res = await getAuthorByID(props.id)
  setName(res?.data?.data?.name)
  setFormImage(`${Baseurl}/view/imageupload/${res?.data?.data?.img}`)
}
if(props.from === 'edituser'){
let data = await getUser(props.id)
setName(data?.data?.firstname)
setLastname(data?.data?.lastname)
setEmail(data?.data?.email)
setMobile(data?.data?.mobile)
setFormImage(`${Baseurl}/view/imageupload/${data?.data?.img}`)
}
if(props.from === 'editEmirates'){
  let res = await getSingleEmirate(props.id)
  if(res?.status === 200){
    setName(res?.data?.name)
    setPrice(res?.data?.price)
  }
}
if(props.from === 'editcode' ){
  let res = await getcodeById(props.uniqueId)
  if(res){
    setName(res?.data?.Name)
    setDescription(res?.data?.description)
    setDisctype(res?.data?.discountType)
    setDiscountamount(res?.data?.discount)
    setValid(res?.data?.valid === true ? 'Yes' : 'No')
    setMinimumpurchaserate(res?.data?.minimumPurchaseRate)
    setRedemtionlimit(res?.data?.maximumRedemtionLimit)
    setDate(new Date(res?.data?.expiryDate))
  }
}
if(props.from === 'editblog'){
  setName(props?.blogdatas?.name)
  setDescription(props?.blogdatas?.description)
  setDate(new Date(props?.blogdatas?.date))
  setValid(props?.blogdatas?.active === true ? options[0] : options[1])
  setFormImage(`${Baseurl}/view/imageupload/${props?.blogdatas?.img}`)
}

if(props.from === 'editboy' ){
let result = await getSingleBoy(props?.id)
setName(result?.data?.name)
setEmail(result?.data?.email)
setMobile(result?.data?.mobile)
}

}

const setAuthorFromDropdown = (author) => {
setAuthor(author.code)
}

useEffect(() => {
(async () => {
  console.log(props,'props');
  
 await  init()
})()
},[])

  return (
    <div>
      <Modal className='modal dark-modal profile-edit fade' show={props.show} onHide={props.handleClose}>
        <Modal.Header closeButton className='border-0'>
          <Modal.Title className='text-white'>{props.category === 'category' ? "ADD CATEGORY" : props.brand === 'brand' ? "ADD BRAND" : props.type === 'type' ? "ADD TYPE" : props.brand === 'editbrand' ? "EDIT BRAND"  : props.from === 'deal' ? "Add Deal" : props.from === 'author' ? 'Add Author' : props.from === 'editauthor' ? 'Edit Author' : props.from === 'edituser' ? 'Edit User' : props.from === 'emirates' ? 'Add Emirates And Price' : props.from === 'editcode' ? 'Edit Promocode' : props.from === 'blog' ? "Add Blog" : props.from === 'editblog' ? 'EditBlog' : props.from === 'addboy' ? 'Add DeliveryBoy' : props.from === 'editboy' ? 'Edit DeliveryBoy' :<></>}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="cm-form">
            <label>{props.from === 'edituser' ? 'Firstname' : props.from === 'emirates' ? 'Country or Emirate Name' :'NAME'}</label>
            <input type="text" value={name} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setName(e.target.value)}} />
            {
              props.from === 'emirates' || props.from === 'editEmirates' ? <>
              <label>Price</label>
              <input type="number" value={price} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setPrice(e.target.value)}} />
              </> : <></>
            }
              {
              props.from === 'addboy' || props.from === 'editboy' ? <>
              <label>Email</label>
              <input type="text" value={email} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setEmail(e.target.value)}} />
              <label>Mobile</label>
              <input type="number" value={mobile} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setMobile(e.target.value)}} />
              </> : <></>
            }
            {
              props.from === 'edituser' ? <>
              <label>Lastname</label>
              <input type="text" value={lastname} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setLastname(e.target.value)}} />
              <label>Email</label>
              <input type="text" value={email} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setEmail(e.target.value)}} />
              <label>Password</label>
              <input type="text" value={password} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setPassword(e.target.value)}} />
              <label>Mobile</label>
              <input type="number" value={mobile} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setMobile(e.target.value)}} />
              </> : <></>
            }
            {
              props.from === 'blog' || props.from === 'editblog' || props.from === 'updatefooter' || props.from === 'code'  || props.from === 'editcode' ?
              <div>
               {props.from === 'blog' || props.from === 'editblog' || props.from === 'updatefooter' || props.from === 'code' || props.from === 'editcode' ?  
               <span><label>DESCRIPTION</label>
                <Editor className="mb-3 text-white" value={description} onTextChange={(e) => setDescription(e.htmlValue)} style={{ height: '220px' }} /> </span> : <></> }
              {props.from === 'blog' || props.from === 'editblog' ?
              <span> <label className='mt-4'>Choose Date</label>
                <Calendar id="buttondisplay" className='ms-5'  showTime
                showSeconds
                dateFormat="yy-mm-dd"
                timeFormat="HH:mm:ss" value={date} onChange={(e) => setDate(e.value)} showIcon /> <br />
                <span className='d-flex justify-content-between mt-3'>
                <label className='mt-4'>Active</label>
                 <SelectButton className='mt-3' value={valid} onChange={(e) => setValid(e.value)} options={options} />
                 </span> 
                <label className='mt-4'>Choose Author</label>
                <FilterImgDrop from={props?.from} authorData={{name: props.blogdatas?.author?.name, code: props.blogdatas?.author?._id, img: props.blogdatas?.author?.img, }} setupAuthor={setAuthorFromDropdown}/> </span> : <></> }
              </div>
                :<></>
            }
            {props.from === 'updatefooter' ? <div>
              <label>Facebook</label>
              <input type="text" value={facebook} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setFacebook(e.target.value)}} />
              <label>Instagram</label>
              <input type="text" value={instagram} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setInstagram(e.target.value)}} />
              <label>Youtube</label>
              <input type="text" value={youtube} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setYoutube(e.target.value)}} />
              <label>Whatsaap Number</label>
              <input type="text" value={whatsaap} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setWhatsaap(e.target.value)}} />
            </div> : <></>}
            {
              props.from === 'code' || props.from === 'editcode' ?
              <div className='pb-3'>
                 <label className='mt-2'>Discount Type</label>
                 <SelectButton value={disctype}  onChange={(e) => setDisctype(e.value)} options={options2} />
                 <label className='mt-3'>{disctype === 'Amount' ? 'Discount Amount' : 'Discount Percentage'}</label>
                 <input type="number" value={discountamount} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setDiscountamount(e.target.value)}} />
                 <span className='d-flex justify-content-around'>
                 <label className='mt-3'>Active</label>
                 <SelectButton className='mt-1' value={valid} onChange={(e) => setValid(e.value)} options={options} />
                 </span>

                 <label className='mt-4'>Minimum Purchase Rate</label>
                 <input type="number" value={minimumpurchaserate} className="form-control"  onChange={(e)=>{setMinimumpurchaserate(e.target.value)}} />
                 
                 {disctype === 'Amount' ? <></> : <p>  
                 <label className='mt-1'>Maximum Redemtion Limit</label>
                 <input type="number" value={redemtionlimit} className="form-control" onChange={(e)=>{setRedemtionlimit(e.target.value)}} /> </p> }

                 <label className='mt-2'>Expiration Date</label>
                <Calendar  id="buttondisplay" className='ms-5 mt-2'  showTime
                showSeconds
                dateFormat="yy-mm-dd"
                timeFormat="HH:mm:ss" value={date} onChange={(e) => setDate(e.value)} showIcon />
              </div>
                :<></>
            }
            { props.category === 'category' || props.from === 'updatefooter' || props.from === 'country' || props.from === 'editcountry' || props.category === 'editcategory' || props.brand === 'brand' || props.brand === 'editbrand' || props.from === 'author' || props.from === 'baner' ||  props.from === 'editbaner' || props.from === 'editauthor' || props.from === 'edituser' || props.from === 'blog' || props.from === 'editblog' ?
            <div className={`${props.from === 'blog'} ? mt-3 : ''`}> 
            <label>{props.from === 'updatefooter' ? 'Logo' : 'Image'}</label>
            <ImageCropper ref={image} aspectRatio={props.brand === 'brand' || props.brand === 'editbrand' || props.from === 'baner' ||  props.from === 'editbaner' ? '' : "1:1" } circleMode={false} lockAspectRatio={props.brand === 'brand' || props.brand === 'editbrand' || props.from === 'baner' ||  props.from === 'editbaner'  ? false : true} />
            {/* <input type="file"  ref={image} className="form-control" placeholder="" accept="image/jpeg, image/png, image/jpg image/svg" onChange={handleImageChange}/> */}
            {formimage ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={formimage}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          />
          <button
            onClick={handleRemoveImage}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>} </div> : <></>  }
          </div>
          {props.from === 'baner' || props.from === 'editbaner' ?

          <div className='cm-form'>
          <label>Heading</label>
          <input type="text" value={titletwo} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setTitletwo(e.target.value)}} />
            <label>Button Path</label>
            <input type="text" value={titlethree} className="form-control" placeholder="Frank Johns" onChange={(e)=>{setTitlethree(e.target.value)}} />
           </div>
          :<></>  
          }
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-between border-0'>
          <button className='cancel' onClick={props.handleClose}>
            Cancel
          </button>
          {/* <button  className='save' onClick={handleSubmit}>
            Save & New
          </button> */}
          <button type='submit' className='save' onClick={handleSubmit}>
            Submit
          </button>
        </Modal.Footer>
      </Modal> 
    </div>
  )
}

export default Addmodal
